import api from '@/api'
import * as types from '../mutation-types'

// initial state
const state = {
  data: []
}

// getters
const getters = {
  catatanGrup: state => state.data,
  getMessages: state => (kodeGrup) => {
    let query = []
    query = state.data.filter(catatan => catatan.kode_grup_form === kodeGrup)
    return query
  }
}

// actions
const actions = {
  getCatatanFormGrupData ({ commit, rootState }) {
    commit(types.FORM_LOADING)
    let kodePenawaran = rootState.auth.data.mhs_jalur.penawaran_jalur.kode_penawaran
    api.get('/v2/catatan_formulir/kode_penawaran/' + kodePenawaran)
      .then(response => {
        let responseData = response.data
        if (responseData.success) {
          commit(types.CATATAN_FORMULIR_RECIEVE, responseData.data)
        } else {
          alert(responseData.message)
        }
        commit(types.FORM_FINISH_LOADING)
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        commit(types.FORM_FINISH_LOADING)
        console.log(e)
      })
  },
  resetCatatanForm ({ commit }) {
    commit(types.CATATAN_FORMULIR_RESET)
  }
}

// mutations
const mutations = {
  [types.CATATAN_FORMULIR_RECIEVE] (state, data) {
    state.data = data
  },
  [types.CATATAN_FORMULIR_RESET] (state) {
    state.data = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/catatan-form.js